import { Row, TableOptions } from 'react-table';

import { InitialSorting, RowColor } from 'types';

import { LoadingWrapper } from 'components/LoadingWrapper';

import { useTableComponent } from './Table.hooks';
import * as S from './Table.styles';
import { StyledTableProps } from './Table.styles';
import { Body } from './components/Body';
import { Head } from './components/Head';
import { Pagination } from './components/Pagination';

type TableProps = TableOptions<{}> &
  StyledTableProps & {
    hasSort?: boolean;
    initialSorting?: InitialSorting[];
    renderRowSubComponent?: Function;
    hideTableOnEmptyFilters?: boolean;
    hasPagination?: boolean;
    hasNoRecords?: boolean;
    isLoading?: boolean;
    renderRowColor?: (row: Row) => RowColor;
    hasApiSorting?: boolean;
    isNested?: boolean;
    tableName?: string;
  };

const defaultProps: Partial<TableProps> = {
  hasSort: false,
  motive: 'm1',
  initialSorting: [],
  hasPagination: false,
  hasNoRecords: false,
  isLoading: false,
  hasApiSorting: false,
  isNested: false,
};

export function Table(props: TableProps): React.ReactElement {
  const {
    columns,
    data,
    motive,
    initialSorting,
    hasSort,
    renderRowSubComponent,
    hasPagination,
    isLoading,
    hasNoRecords,
    renderRowColor,
    hasApiSorting,
    isNested,
    tableName,
  } = {
    ...defaultProps,
    ...props,
  };
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    visibleColumns,
    pageIndex,
    pageSize,
  } = useTableComponent(columns, data, initialSorting, hasApiSorting, isNested);

  return (
    <LoadingWrapper isLoading={isLoading!} hasBackdrop>
      <S.Wrapper>
        <S.Table {...getTableProps()} motive={motive}>
          <Head headerGroups={headerGroups} hasSort={hasSort} />

          <Body
            renderRowColor={renderRowColor}
            hasNoRecords={hasNoRecords}
            data={data}
            getTableBodyProps={getTableBodyProps}
            rows={rows}
            prepareRow={prepareRow}
            renderRowSubComponent={renderRowSubComponent}
            visibleColumns={visibleColumns}
          />
        </S.Table>
      </S.Wrapper>

      {hasPagination && data && data.length > 0 ? (
        <Pagination
          canPreviousPage={canPreviousPage}
          canNextPage={canNextPage}
          gotoPage={gotoPage}
          previousPage={previousPage}
          nextPage={nextPage}
          pageIndex={pageIndex}
          pageSize={pageSize}
          pageOptions={pageOptions}
          setPageSize={setPageSize}
          tableName={tableName}
        />
      ) : null}
    </LoadingWrapper>
  );
}
